import { faTrash } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "../../Icon/Icon";
import { TileButton, TileButtonProps } from "./TileButton";

interface TileDeleteButtonProps extends Omit<TileButtonProps, "aria-label"> {
  onAction: (event: React.MouseEvent, action: "DELETE") => void;
  ariaLabel?: string;
}

export const TileDeleteButton = (props: TileDeleteButtonProps) => {
  const { onAction, ariaLabel = "Delete", ...rest } = props;

  const handleAction = (e: React.MouseEvent) => {
    e.stopPropagation();
    onAction(e, "DELETE");
  };

  return (
    <TileButton
      aria-label={ariaLabel}
      data-testid="btn-delete"
      onClick={handleAction}
      {...rest}
    >
      <Icon icon={faTrash} fontSize="small" />
    </TileButton>
  );
};
